//https://facetwp.com/help-center/facets/facet-types/pager/
//document.addEventListener("DOMContentLoaded", this.ready.bind(this));
document.addEventListener("facetwp-refresh", function () {
	if (FWP.soft_refresh == true) {
		FWP.enable_scroll = true;
	} else {
		FWP.enable_scroll = false;
	}
});
document.addEventListener("facetwp-loaded", function () {
	if (FWP.enable_scroll == true) {
		document
			.querySelector(".is-listing")
			.scrollIntoView({ behavior: "smooth" }, true);
	}
});
